/** Format persisted BloodCrimesTV schedule timestamps in the UTC timezone. */
export function formatBloodCrimesTvUtcTime(value: string): string {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return 'nieprawidłowa data';
  return new Intl.DateTimeFormat('pl-PL', {
    timeZone: 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(date);
}
